/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useSnackbar, closeSnackbar } from 'notistack';
import closeIconToast from '../assets/icons/closeIconToast.png';

let snackBarUtils;
export function SnackbarUtilsConfigurator() {
  snackBarUtils = useSnackbar();
  return null;
}

export default {
  success(msg) {
    this.toast(msg, 'success');
  },
  warning(msg) {
    this.toast(msg, 'warning');
  },
  info(msg) {
    this.toast(msg, 'info');
  },
  error(msg) {
    this.toast(msg, 'error');
  },
  toast(msg, variant) {
    snackBarUtils.enqueueSnackbar(msg, {
      variant,
      action: (key) => (
        <img
          style={{
            position: 'absolute', top: '10px', right: '10px', cursor: 'pointer',
          }}
          src={closeIconToast}
          onClick={() => closeSnackbar(key)}
          alt=""
        />
      ),
    });
  },
};
